import type {GetTokens, Prize} from './types';
import type {Schemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpDelete, httpGet, httpPost, httpPut} from './http/ebba';
import {mapPrizeSearchDto} from './mappers';
import {
  mapGetPrizeDto,
  mapToCreatePrizeDto,
  mapToUpdatePrizeDto,
} from './mappers/mapPrizeDto';
import type {SearchResult} from './searchTypes';

export const getPrize = (
  id: string,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Prize> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.LiteraturePrizeWithWinners>({
      subdir: 'literatureprize/{id}',
      subdirParams: {id},
      mock,
      getTokens,
    }).then(mapGetPrizeDto),
  );
};

export const getAllPrizes = (
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Prize> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.LiteraturePrizeWithWinners>({
      subdir: 'literatureprize',
      mock,
      getTokens,
    }).then(mapGetPrizeDto),
  );
};

export const searchPrize = (
  query: string,
  page: number,
  size: number,
  getTokens: GetTokens,
  _?: AbortSignal,
): Promise<SearchResult<Prize>> => {
  const emptySearch = query.trim() === '' || query.trim() === '*';
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.LiteraturePrizesPageResponse, SearchResult<Prize>>({
      subdir: 'literatureprize/search',
      queryParams: {
        name: emptySearch ? '' : query,
        page,
        size,
        sort: emptySearch ? 'name' : undefined,
      },
      getTokens,
    }).then(dto => mapPrizeSearchDto(query, dto)),
  );
};

export const postPrize = (
  prize: Prize,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Prize> => {
  return exceptionToPromiseReject(() =>
    httpPost<
      Schemas.LiteraturePrizeWithWinners,
      Schemas.CreateLiteraturePrizeRequest
    >({
      subdir: 'literatureprize',
      mock,
      body: mapToCreatePrizeDto(prize),
      getTokens,
      // }).then( mapGetPrizeDto),
    }).then(({id}) => getPrize(id, getTokens)),
  );
};

export const putPrize = (
  prize: Prize,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Prize> => {
  return exceptionToPromiseReject(() =>
    httpPut<
      Schemas.LiteraturePrizeWithWinners,
      Schemas.UpdateLiteraturePrizeRequest
    >({
      subdir: 'literatureprize/{id}',
      subdirParams: {id: prize.id},
      mock,
      body: mapToUpdatePrizeDto(prize),
      getTokens,
    }).then(mapGetPrizeDto),
  );
};

export const deletePrize = (
  id: string,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpDelete({
      subdir: 'literatureprize/{id}',
      subdirParams: {id},
      getTokens,
      mock,
    }),
  );
};
